(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("NOWPaymentsApiJS", [], factory);
	else if(typeof exports === 'object')
		exports["NOWPaymentsApiJS"] = factory();
	else
		root["NOWPaymentsApiJS"] = factory();
})(this, function() {
return 